@if (!isLoading) {
  <div class="main-content">
    <div class="flex-c align-self-stretch">
      <div class="page-title justify-space-between padding-36-0">
        <div class="font-bold-display-medium title">Rechnungsdetails</div>
        <!-- add status -->
        <div [class]="getStatus(invoice).class">
          {{ getStatus(invoice).status }}
        </div>
      </div>

      <div class="header">
        <img
          src="../../../../../../assets/images/logo-wide.svg"
          height="78px"
          alt="InstitutWissen" />
        Institut Wissen gUG | Kreuzstraße 7 | 77716 Hofstetten | Tel: +49 1522
        43 41 641 | wissen.institute
      </div>
    </div>
    <div class="flex-r align-self-stretch">
      <span class="font-regular-title-large underlined font-color-black">
        {{ invoice?.seminar?.title }}
      </span>
    </div>
    <div class="flex-r gap-24 align-self-stretch font-color-black">
      <div class="flex-c gap-8">
        <span>
          Rechnungsdatum: {{ invoice?.generatedAt | date: 'dd.MM.yyyy' }}
        </span>
        <span>
          Zahlungsart:
          {{ invoice?.paymentMethod === 'paypal' ? 'PayPal' : 'Überweisung' }}
        </span>
      </div>
      <div class="flex-c gap-8">
        <span>Rechnungsnummer: {{ invoice?.invoiceNr }}</span>
        @if (invoice.bookingNr) {
          <span>Buchungsnummer: {{ invoice?.bookingNr }}</span>
        }
        @if (invoice.seminar) {
          <span>Seminar ID: {{ invoice?.seminar?.seminarNr }}</span>
        }
      </div>
    </div>
    <div class="container gap-16 font-color-black">
      <div
        class="flex-r justify-space-between gap-10 align-center align-self-stretch flex-1-1-0 cursor-pointer">
        <div class="title flex-r align-center gap-8">
          <i class="fa-regular fa-receipt fa-2x"></i>
          <span class="font-regular-title-large">Rechnungsanschrift</span>
        </div>
      </div>
      <span>
        Diese Informationen sind wichtig, um die Rechnung zu erstellen und dich
        im Falle von Rückfragen bezüglich der Kursanmeldung zu kontaktieren.
      </span>
      @if (invoice?.facility) {
        <div class="flex-c gap-8">
          <div class="font-medium-title-medium">Einrichtung</div>
          <div class="font-regular-body-large pre-line">
            {{ invoice.facility }}
          </div>
        </div>
        <p-divider class="form-divider"></p-divider>
      }
      <div class="flex-r gap-24">
        <div class="flex-c gap-8">
          <div class="font-medium-title-medium">Vorname</div>
          <div class="font-regular-body-large">
            {{ invoice?.firstName }}
          </div>
        </div>
        <div class="flex-c gap-8">
          <div class="font-medium-title-medium">Nachname</div>
          <div class="font-regular-body-large">
            {{ invoice?.lastName }}
          </div>
        </div>
      </div>
      <p-divider class="form-divider"></p-divider>
      <div class="flex-c gap-8">
        <div class="font-medium-title-medium">Adresse</div>
        <div class="font-regular-body-large">
          {{ invoice?.street }}
          {{ invoice?.streetNr }}
          <br />
          {{ invoice?.zip }}
          {{ invoice?.city ? invoice.city + ',' : '' }}
          {{ invoice?.country }}
        </div>
      </div>
      <p-divider class="form-divider"></p-divider>
      <div class="flex-r gap-24">
        <div class="flex-c gap-8">
          <div class="font-medium-title-medium">E-Mail</div>
          <div class="font-regular-body-large">
            {{ invoice?.email }}
          </div>
        </div>
        <div class="flex-c gap-8">
          <div class="font-medium-title-medium">Telefon</div>
          <div class="font-regular-body-large">
            {{ invoice?.phoneNumber }}
          </div>
        </div>
      </div>
    </div>

    @if (invoice.positions && invoice.positions.length > 0) {
      <div class="container">
        <div
          class="flex-r justify-space-between gap-10 align-center align-self-stretch flex-1-1-0 cursor-pointer">
          <div class="title flex-r align-center gap-8">
            <i class="fa-regular fa-cart-shopping fa-2x"></i>
            <span class="font-regular-title-large"> Positionen </span>
          </div>
        </div>
        <div class="flex-c gap-16 font-color-black">
          @for (position of invoice.positions; track $index) {
            <div class="flex-r gap-24 flex-wrap">
              <div class="flex-c gap-8">
                <div class="font-medium-title-medium">Position</div>
                <div class="font-regular-body-large text-align-center">
                  {{ position.position }}
                </div>
              </div>
              <div class="flex-c gap-8">
                <div class="font-medium-title-medium">Anzahl</div>
                <div class="font-regular-body-large text-align-center">
                  {{ position.quantity }}
                </div>
              </div>
              <div class="flex-c gap-8 flex-1-1-0">
                <div class="font-medium-title-medium">Titel</div>
                <div class="font-regular-body-large">
                  {{ position.title }}
                </div>
              </div>
              <div class="flex-c gap-8">
                <div class="font-medium-title-medium">Einzelpreis</div>
                <div class="font-regular-body-large text-align-end">
                  {{ position.price | currency: 'EUR' }}
                </div>
              </div>
              <div class="flex-c gap-8">
                <div class="font-medium-title-medium">Gesamtpreis</div>
                <div class="font-regular-body-large text-align-end">
                  {{ position.total | currency: 'EUR' }}
                </div>
              </div>
            </div>
            @if ($index < invoice.positions.length - 1) {
              <p-divider class="form-divider"></p-divider>
            }
          }
        </div>
      </div>
    }
    <div class="container gap-16">
      <div class="flex-r align-center justify-space-between align-self-stretch">
        <div class="title flex-r align-center gap-8">
          <i class="fa-regular fa-euro-sign fa-2x"></i>
          <span class="font-regular-title-large"> Gesamtbetrag </span>
        </div>
        <div class="font-bold-title-large">
          {{
            (invoiceType === InvoiceTypeEnum.BOOKING
              ? invoice.totalAmount
              : invoice.discountedAmount
            ) | currency: 'EUR'
          }}
        </div>
      </div>
      @if (invoice.coupons?.length > 0) {
        <p-divider class="form-divider"></p-divider>
        @for (couponCode of invoice.coupons; track $index) {
          <div
            class="flex-r justify-space-between align-self-stretch align-center">
            <div class="inwi-chip-text-green-outline">
              Coupon: {{ couponCode.code }}
            </div>
            <div class="font-regular-title-medium">
              @if (couponCode.discountType === 'percentage') {
                -{{
                  invoice.totalAmount * (couponCode.value / 100)
                    | currency: 'EUR'
                }}
              } @else {
                -{{ couponCode.value | currency: 'EUR' }}
              }
            </div>
          </div>
        }
        <div class="font-bold-title-large flex-r justify-end">
          Total:
          {{
            invoice.discountedAmount ?? invoice.totalAmount | currency: 'EUR'
          }}
        </div>
      }
    </div>
    <div class="flex-c gap-24 align-self-stretch">
      <strong>Bankverbindung</strong>
      <div class="bank-info">
        <div class="flex-c gap-4">
          <span>Kontoinhaber: Institut Wissen gUG</span>
          <span>IBAN: DE84 6645 1548 0000 6241 31</span>
          <span>BIC: SOLADES1HAL</span>
          <span>Bankname: Sparkasse Kinzigtal</span>
        </div>
        <div class="flex-c gap-4">
          <span>Kontoinhaber: Vanessa Marie Diel</span>
          <span>IBAN: DE72 1001 1001 2364 2106 55</span>
          <span>BIC: NTSBDEB1</span>
          <span>Bankname: N26 Bank</span>
        </div>
      </div>
      <span>Verwendungszweck: {{ invoice.invoiceNr }}</span>
    </div>
  </div>
  @if (invoice?.paymentStatus === 'unpaid') {
    <div class="sticky-container-bottom">
      <button
        type="button"
        class="inwi-icon-text-button-large-secondary"
        (click)="onGoBack()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-xmark"></i>
          </div>
          <div class="button-text">Abbrechen</div>
        </div>
      </button>
      <button
        type="button"
        class="inwi-icon-text-button-large-secondary"
        (click)="onDownloadInvoice()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-arrow-down-to-line"></i>
          </div>
          <div class="button-text">Herunterladen</div>
        </div>
      </button>
      <button
        type="submit"
        class="inwi-icon-text-button-large-primary"
        (click)="onApprovePayment()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-check-double"></i>
          </div>
          <div class="button-text">Zahlung genehmigen</div>
        </div>
      </button>
    </div>
  } @else {
    <div class="sticky-container-bottom">
      <button
        type="submit"
        class="inwi-icon-text-button-large-secondary"
        (click)="onDownloadInvoice()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-arrow-down-to-line"></i>
          </div>
          <div class="button-text">Herunterladen</div>
        </div>
      </button>
    </div>
  }
}
